import { Component, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { InvState } from '../../../model/api/inventory/inv-state';
import { PagedResult } from '../../../model/common/paged-result';
import { Param } from '../../../model/common/param';
import { InvStateHttpService } from '../../../services/http/inventory/inv-state.http.service';
import { GenericManage } from '../../generic/generic.manage';

@Component({
    selector: 'inv-state-manage',
    templateUrl: 'inv-state.manage.html',
    providers: [ InvStateHttpService ]
})
export class InvStateManage extends GenericManage<InvState, number> {

     @ViewChild('itemDetailModal') modal: ModalDirective;

    public filter: string = '';
    isCollapsed: boolean = true;

    constructor(public invStateHttpService: InvStateHttpService) {
        super();
    }

     public detailInitialize() {
        this.modal.show();
    }

    public detailTerminate() {
        this.modal.hide();
    }

    public exportToExcel() {

        let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.invStateHttpService.get(1, 1000000, 'name', 'asc', params, null).subscribe(
            (data: PagedResult<InvState>) => {

                let options = {
                    sheetid: 'asset-states',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // alasql(`SELECT id as [Id], 
                //     code as [Code],
                //     name as [Description] 
                //     INTO XLSX("asset-states.xlsx",?) FROM ?`, [ options, data.items ]);

            });
    }

    


    collapsed(event: any): void {
      // console.log(event);
    }
  
    expanded(event: any): void {
      // console.log(event);
    }
}
